import { render, staticRenderFns } from "./shopEdit.vue?vue&type=template&id=545ef790&scoped=true&"
import script from "./shopEdit.vue?vue&type=script&lang=js&"
export * from "./shopEdit.vue?vue&type=script&lang=js&"
import style0 from "./shopEdit.vue?vue&type=style&index=0&id=545ef790&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ef790",
  null
  
)

export default component.exports